import styled from 'styled-components';
import { Typ20, Typ41 } from '../Typ';

export const ElementWrapper = styled.div`
  flex-direction: column;
  text-align: center;
  height: 38px;
  flex-grow: 1;
`;

type ThemeProps = {
  $themeName?: 'light' | 'dark';
};

export const CounterText = styled(Typ41)<ThemeProps>`
  display: block;
  width: 100%;
  text-align: center;
  color: ${props => (props.$themeName === 'dark' ? '#fff' : '#263238')};
`;

export const ContentText = styled(Typ20)<ThemeProps>`
  text-align: center;
  color: ${props =>
    props.$themeName === 'dark' ? 'rgba(255, 255, 255, 0.40)' : '#90A4AE'};
  display: block;
`;
